// Skills icons - https://react-icons.github.io/react-icons/
import {
  FaHtml5,
  FaCss3Alt,
  FaBootstrap,
  FaReact,
  FaGitAlt,
  FaGithubSquare,
  FaLink,
} from "react-icons/fa";
import {
  DiAndroid,
  DiDart,
  DiJava,
  DiJsBadge,
  DiNpm,
  DiPython,
  DiReact
} from "react-icons/di"
import { SiJavascript, SiStyledcomponents, SiRedux } from "react-icons/si";

import Logo from "./images/android.png";
import Augmented from './images/augmented.png';
import Gdsc from './images/gdsc.png';
import Spotify from './images/spotify.png'

import HeroLight from "./images/space.jpg";
import HeroDark from "./images/space.jpg";
export { HeroLight as Light };
export { HeroDark as Dark };


export const githubUsername = "aadityaguptaa";

// Blog link icon (imported above)
export const Blog = <FaLink href="https://adityaguptaa.hashnode.dev/"/>;


export const moreInfo =
  "Hi, I'm Aditya, an Android Developer, who loves exploring different stuff. Currently I'm a 4th year ISE student @NIE. I am a potterhead and greek mythology enthusiast who mainly programs in Kotlin. I am also trying out ML to see what all the fuss is about and might actually ❤ it.";


export const skillData = [
  {
    id: 1,
    skill: <DiAndroid className="display-4" />,
    name: "Android",
  },
  {
    id: 2,
    skill: <DiReact className="display-4" />,
    name: "React",
  },
  {
    id: 3,
    skill: <DiJava className="display-4" />,
    name: "Java",
  },
  {
    id: 4,
    skill: <DiDart className="display-4" />,
    name: "Dart",
  },
  {
    id: 5,
    skill: <DiPython className="display-4" />,
    name: "Python",
  },
  {
    id: 6,
    skill: <DiJsBadge className="display-4" />,
    name: "Java Script",
  },
  {
    id: 7,
    skill: <DiNpm className="display-4" />,
    name: "NPM",
  },
  {
    id: 8,
    skill: <FaGitAlt className="display-4" />,
    name: "Git",
  },
  {
    id: 9,
    skill: <FaGithubSquare className="display-4" />,
    name: "GitHub",
  },
];

// Resume link (string - "https://YourResumeUrl") - I am using CloudFront to share my resume (https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/Introduction.html)
export const resume = "https://drive.google.com/file/d/1N5awivljIO3VkSkf5anhc5VuyqaAF-q5/view?usp=sharing";


export const filteredProjects = ["AR-companion", "songerated", "GDSC-NIE-Android"];

export const projectCardImages = [
  {
    name: "AR-companion",
    image: Augmented,
  },
  {
    name: "GDSC-NIE-Android",
    image: Gdsc,
  },
  {
    name: "songerated",
    image: Spotify,
  }
];


export const formspreeUrl = "https://formspree.io/f/YourEndpoint";
